module.exports = __webpack_public_path__ + "static/media/itchidash.8325e674.svg";